"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _overview = require("@insided/control/modules/MultiLanguage/Translation/overview");

var _common = require("@insided/shared/utils/common");

var _Language = _interopRequireDefault(require("@insided/shared/icons/Language"));

var _classnames = _interopRequireDefault(require("classnames"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function getTitleForLanguageCode(languageCode, languages) {
  var _languages$find;

  var locale = languages === null || languages === void 0 ? void 0 : (_languages$find = languages.find(function (language) {
    return language.code === languageCode;
  })) === null || _languages$find === void 0 ? void 0 : _languages$find.locale;
  if (!locale) return languageCode;
  return locale.replace('_', '-').toUpperCase();
}

var LanguageSwitcher = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(LanguageSwitcher, _Component);

  var _super = _createSuper(LanguageSwitcher);

  function LanguageSwitcher() {
    var _this;

    (0, _classCallCheck2.default)(this, LanguageSwitcher);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "dropdownTimeout", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isDropdownOpen: false,
      selectedLanguage: {
        title: getTitleForLanguageCode(_this.props.selectedLanguageCode, _this.props.languages),
        value: _this.props.selectedLanguageCode
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "mapLanguagesToDropdownItems", function (languages) {
      var selectedLanguage = _this.props.selectedLanguageCode;
      return languages.filter(function (language) {
        return selectedLanguage && language.code !== selectedLanguage;
      }).map(function (language) {
        return {
          title: "".concat(language.name).concat(language.isDefault ? ' (Default)' : ''),
          onClick: function onClick() {
            return _this.onLanguageSelected(language);
          },
          value: language.locale
        };
      });
    });
    return _this;
  }

  (0, _createClass2.default)(LanguageSwitcher, [{
    key: "onMouseEnter",
    value: function onMouseEnter() {
      if (this.dropdownTimeout) clearTimeout(this.dropdownTimeout);
    }
  }, {
    key: "onMouseLeave",
    value: function onMouseLeave() {
      var _this2 = this;

      this.dropdownTimeout = setTimeout(function () {
        return _this2.setState({
          isDropdownOpen: false
        });
      }, 300);
    }
  }, {
    key: "toggleDropdown",
    value: function toggleDropdown() {
      var isDropdownOpen = this.state.isDropdownOpen;
      if (this.dropdownTimeout) clearTimeout(this.dropdownTimeout);
      this.setState({
        isDropdownOpen: !isDropdownOpen
      });
    }
  }, {
    key: "closeDropdown",
    value: function closeDropdown() {
      this.setState({
        isDropdownOpen: false
      });
    }
  }, {
    key: "onLanguageSelected",
    value: function onLanguageSelected(language) {
      var _this3 = this;

      var _this$props = this.props,
          onLanguageChanged = _this$props.onLanguageChanged,
          languages = _this$props.languages;
      this.setState({
        selectedLanguage: {
          title: getTitleForLanguageCode(language.code, languages),
          value: language.code
        }
      }, function () {
        _this3.closeDropdown();

        onLanguageChanged === null || onLanguageChanged === void 0 ? void 0 : onLanguageChanged(language.code);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this,
          _selectedLanguage$val,
          _languageOptions;

      var _this$props2 = this.props,
          languages = _this$props2.languages,
          selectedLanguageCode = _this$props2.selectedLanguageCode,
          userRoles = _this$props2.userRoles,
          allowedUserRoles = _this$props2.allowedUserRoles,
          enabledLanguages = _this$props2.enabledLanguages,
          publishedLanguages = _this$props2.publishedLanguages;
      var _this$state = this.state,
          isDropdownOpen = _this$state.isDropdownOpen,
          selectedLanguage = _this$state.selectedLanguage;

      var isContentInPreferredLanguageEnabled = _common.common.isModuleActive('contentInPreferredLanguage');

      var isPublishedLanguagesVisible = isContentInPreferredLanguageEnabled && userRoles.some(function (role) {
        return allowedUserRoles.includes(role);
      });
      var languageOptions = [];
      var enabledLanguagesDropdownItems = enabledLanguages !== null && enabledLanguages !== void 0 && enabledLanguages.length ? this.mapLanguagesToDropdownItems(enabledLanguages) : [];
      var publishedLanguagesDropdownItems = publishedLanguages !== null && publishedLanguages !== void 0 && publishedLanguages.length ? this.mapLanguagesToDropdownItems(publishedLanguages) : [];
      var groupedLanguages = [{
        groupName: 'Published languages',
        items: publishedLanguagesDropdownItems
      }, {
        groupName: 'Unpublished languages',
        items: enabledLanguagesDropdownItems
      }];

      if (languages !== null && languages !== void 0 && languages.length) {
        languageOptions = languages.filter(function (_ref) {
          var code = _ref.code;
          return code.toLowerCase() !== (selectedLanguageCode === null || selectedLanguageCode === void 0 ? void 0 : selectedLanguageCode.toLowerCase());
        }).sort(function (a, b) {
          return a.name < b.name ? -1 : 1;
        });
      }

      return (0, _preact.h)("li", {
        className: "main-navigation--language-switcher",
        onMouseEnter: function onMouseEnter() {
          return _this4.onMouseEnter();
        },
        onMouseLeave: function onMouseLeave() {
          return _this4.onMouseLeave();
        }
      }, isPublishedLanguagesVisible ? (0, _preact.h)(_overview.LanguagesDropdown, {
        languages: groupedLanguages,
        selectedLanguage: this.state.selectedLanguage,
        hasArrowIcon: false
      }) : languages && languages.length > 1 && (0, _preact.h)("div", null, (0, _preact.h)("div", {
        className: "main-navigation--language-switcher_selected",
        tabIndex: 0,
        role: "button",
        onClick: function onClick() {
          return _this4.toggleDropdown();
        },
        onKeyDown: function onKeyDown(event) {
          if (event.key === 'Enter') {
            _this4.toggleDropdown();
          }
        }
      }, _common.common.isModuleActive('showLanguageFlags') ? (0, _preact.h)("div", {
        className: (0, _classnames.default)('main-navigation--language-switcher_language-icon', "main-navigation--language-switcher_language-icon--".concat((_selectedLanguage$val = selectedLanguage.value) === null || _selectedLanguage$val === void 0 ? void 0 : _selectedLanguage$val.toLowerCase()))
      }) : (0, _preact.h)(_Language.default, {
        height: 16,
        width: 16
      }), (0, _preact.h)("span", null, selectedLanguage.title)), isDropdownOpen && (0, _preact.h)("div", {
        className: "main-navigation--language-switcher_dropdown"
      }, (_languageOptions = languageOptions) === null || _languageOptions === void 0 ? void 0 : _languageOptions.map(function (language) {
        return (0, _preact.h)("div", {
          className: "main-navigation--language-switcher_dropdown_item",
          onClick: function onClick() {
            return _this4.onLanguageSelected(language);
          },
          onKeyDown: function onKeyDown() {
            return _this4.onLanguageSelected(language);
          },
          key: "language-".concat(language.code),
          role: "button",
          tabIndex: 0
        }, _common.common.isModuleActive('showLanguageFlags') && (0, _preact.h)("a", {
          className: (0, _classnames.default)('main-navigation--language-switcher_language-icon', "main-navigation--language-switcher_language-icon--".concat(language.code.toLowerCase())),
          "data-value": language.code.toLowerCase()
        }), (0, _preact.h)("span", null, language.name));
      }))));
    }
  }]);
  return LanguageSwitcher;
}(_preact.Component);

exports.default = LanguageSwitcher;